
import React from 'react';
import Header from '@/components/Header';

const OrganisationLoading: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <main className="container mx-auto px-4 py-8">
        <div className="flex justify-center items-center h-64">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900 mx-auto mb-4"></div>
            <p className="text-lg text-gray-600">Loading organisation profile...</p>
          </div>
        </div>
      </main>
    </div>
  );
};

export default OrganisationLoading;
